import { __decorate } from 'tslib';
import { ChangeDetectorRef, Pipe, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
let WaitABitPipe = class WaitABitPipe {
    constructor(
    // Dependencies
    cd) {
        this.cd = cd;
        this.returnedOnce = false;
    }
    transform(value, configObject) {
        var _a, _b, _c, _d, _e, _f, _g;
        const initialValue = (_a = configObject) === null || _a === void 0 ? void 0 : _a.initial;
        const delay = (_b = configObject) === null || _b === void 0 ? void 0 : _b.delay;
        const cancelPrevious = ((((_c = configObject) === null || _c === void 0 ? void 0 : _c.cancelPrevious) !== undefined) && (((_d = configObject) === null || _d === void 0 ? void 0 : _d.cancelPrevious) !== null)) ? configObject.cancelPrevious : true;
        const immediate = ((((_e = configObject) === null || _e === void 0 ? void 0 : _e.immediate) !== undefined) && (((_f = configObject) === null || _f === void 0 ? void 0 : _f.immediate) !== null)) ? configObject.immediate : false;
        const trace = !!((_g = configObject) === null || _g === void 0 ? void 0 : _g.trace);
        if (trace)
            console.log('-----------------------------');
        if (trace)
            console.log('initialValue', initialValue);
        if (trace)
            console.log('delay', delay);
        if (trace)
            console.log('cancelPrevious', cancelPrevious);
        if (trace)
            console.log('immediate', immediate);
        // Initialize
        if (!this.returnedOnce)
            this.lastEmittedValue = initialValue !== undefined ? initialValue : value;
        // Change if necessary
        if (value !== this.lastPassedValue) {
            if (cancelPrevious) {
                if (this.lastRaf)
                    cancelAnimationFrame(this.lastRaf);
                clearTimeout(this.lastTimeout);
            }
            if (immediate)
                this.lastEmittedValue = value;
            else {
                const onTimePast = () => {
                    this.lastEmittedValue = value;
                    this.cd.markForCheck();
                };
                if (!delay)
                    this.lastRaf = requestAnimationFrame(onTimePast);
                else
                    this.lastTimeout = window.setTimeout(onTimePast, delay);
            }
            this.lastPassedValue = value;
        }
        if (!this.returnedOnce)
            this.returnedOnce = true;
        if (trace)
            console.log('spits out', this.lastEmittedValue);
        return this.lastEmittedValue;
    }
};
WaitABitPipe.ɵfac = function WaitABitPipe_Factory(t) { return new (t || WaitABitPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef, 16)); };
WaitABitPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "waitABit", type: WaitABitPipe, pure: false });
WaitABitPipe.ctorParameters = () => [
    { type: ChangeDetectorRef }
];

let WaitABitModule = class WaitABitModule {
};
WaitABitModule.ɵfac = function WaitABitModule_Factory(t) { return new (t || WaitABitModule)(); };
WaitABitModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: WaitABitModule });
WaitABitModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WaitABitPipe, [{
        type: Pipe,
        args: [{
                name: 'waitABit',
                pure: false
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WaitABitModule, [{
        type: NgModule,
        args: [{
                declarations: [WaitABitPipe],
                exports: [WaitABitPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WaitABitModule, { declarations: [WaitABitPipe], exports: [WaitABitPipe] }); })();

/*
 * Public API Surface of angular-wait-a-bit
 */

/**
 * Generated bundle index. Do not edit.
 */

export { WaitABitModule, WaitABitPipe as ɵa };

